import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector} from 'react-redux'
import { Button } from "@material-ui/core"
import AddBoxIcon from '@material-ui/icons/AddBox';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import Divider from '@material-ui/core/Divider';
import { getUserPreference } from '../../../utilities/common';
import _ from 'lodash';
import EditIncidentFormDialog from '../../IncidentManagement/EditIncidentForm/dialog';
import { getAllDropDownFields, getIncidentCount } from "../../../actions/incidentManagementActions";
import { useAlert } from "../../../utilities/hooks";
import { alertType } from "../../../components/Common/UniAlert/context";
import { getAllUsers, getBranchList } from "../../../actions/commonAction";
import { getOpenIncidentFormDialog, handleOpenIncidentFormDialog } from "../../../reducers/uiSlice";

const useStyles = makeStyles({
    root: {
      maxWidth: 345,
    },
    p:{
        marginLeft: 16,
    },
    head:{
        marginLeft: 16,
        marginTop: 10,
    }
  });
export default function IncidentBox(props){
    const classes = useStyles();
    const {incidentList, disabled, trackingNumber} = props;
    const {t} = useTranslation('editOrder');    
    const dispatch = useDispatch();
    let userPref = getUserPreference();
    const statusList = useSelector(state => state.incidentManagement.statusList);
    const userList = useSelector(state => state.common.users);
    const [incidentId, setIncidentId] = useState('');
    const alertDialog = useAlert();
    const openIncidentForm = useSelector(getOpenIncidentFormDialog);

    useEffect(()=> {
        initialCalls()
    }, [])

    const initialCalls = () => {
        Promise.all([
            dispatch(getBranchList()), 
            dispatch(getAllDropDownFields()), 
            dispatch(getAllUsers()),
            dispatch(getIncidentCount()),
        ]).catch( error => {
            //This page needs these values to work properly, so we ask users to retry
            alertDialog.addAlertDialog(
                t('incident_management'), 
                `${t('dialog:initialize_failed')} ${t('common:retry')}`, 
                alertType.ERROR, 
                t('common:retry'),
                ()=>{
                    initialCalls();
                    alertDialog.hideAlert();
                }, 'primary', false, false);
            alertDialog.showAlert();
        })
    }


    const getNameById = (value, list) => {
        //getValue from data-grid is bugged in this current version
        return _.find(list, { 'id': value })?.name || value
      }

     const getUserById = (id, list = []) => {
        return _.find(list, {'id': Number(id)})
    }

    return (
        <div style={{width: '100%', paddingTop: 0, paddingLeft: 10, paddingRight: 16}}>
            <EditIncidentFormDialog
                open={openIncidentForm.open}
                investigationId={openIncidentForm.id}
                onClose={(isUpdated) => {
                    dispatch(handleOpenIncidentFormDialog({open: false}));
                }}
                trackingNumber={trackingNumber}
                incidentList = {incidentList}
                maxWidth="md"
                disableDefaultButtons
                fullWidth
            />
            {incidentList.map((incident, index)=>(
                <div key={index} onClick={() => handleViewIncident(incident.id)}>
                <Card  className={classes.root} variant="outlined">  
                <CardActionArea>
                <Typography className={classes.head}>ID: {incident.id}</Typography>
                <Typography className={classes.p}>Level: {getNameById(incident.level, statusList.incidentLevelList)}</Typography>
                <Typography className={classes.p}>Status: {getNameById(incident.status, statusList.incidentStatusList)}</Typography>
                <Typography className={classes.p}>HandleBy: {getUserById(incident.handler, userList)?.username || "N/A"}</Typography>
                </CardActionArea>
                <CardActions>
                <Button 
                    style={{marginLeft: 0}}
                >
                    {t('more_detail')}</Button>
                </CardActions>
                <Divider/>
                </Card> 
                <br/>
                </div>
            ))}
            <Button
                variant="contained"
                color='secondary'
                startIcon={<AddBoxIcon />}
                fullWidth
                style={{marginTop: 16, marginLeft: 0}}
                onClick={handleCreateIncident}
            >
                {t('button_create_new')}
            </Button>
        </div>
    )

    function handleCreateIncident(){
        dispatch(handleOpenIncidentFormDialog({open: true}));
    }

    function handleViewIncident(id){
        dispatch(handleOpenIncidentFormDialog({open: true, id: id}));
    }
}